import React from 'react';
import styled from 'styled-components';
import ImageContainer from './index';
import { sizeMixin } from '../MyApps/Clock';

export const TileContainer = styled.div<any>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 3px;

  ${({ premiumTileIcon }) => premiumTileIcon ?
    `background: url(${premiumTileIcon}) center center / contain no-repeat;` :
    ''
  }

  ${({ size, tileBezelWidth }) => size ? sizeMixin(size, tileBezelWidth) : ''}
`;

export const TileImage = styled(({ image, name, ...props }) => (
  <ImageContainer
    {...props}
    containerAttr={{
      width: image.width,
      height: image.height
    }}
    imageAttr={{
      alt: name,
      src: image.uri
    }}
  />
))`
    
  ${({ image, tileWidth }) => image ? sizeMixin(image, tileWidth) : ''}
  
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  transform: translate(-50%, -50%);
  
`;
